import type { StepDto } from '@lex/contracts';
import { Glow, SectionHeader } from './primitives';

export function StepsSection({ steps }: { steps: StepDto[] }) {
  return (
    <section
      id="how-it-works"
      className="relative scroll-mt-24 overflow-hidden px-4 py-14 md:px-8 md:py-20 xl:px-20"
    >
      <Glow color="blue" size={480} opacity={0.16} blur={70} className="left-10 top-10 hidden lg:block" />

      <div className="relative mx-auto flex max-w-[1280px] flex-col gap-10 md:gap-12">
        <SectionHeader
          eyebrow="Как это работает"
          title="Три шага до понятного решения"
          subtitle="Никаких сложных схем: опишите ситуацию — дальше ведём вас мы."
        />

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {steps.map((step) => (
            <div key={step.id} className="flex flex-col gap-4 rounded-3xl border border-line bg-white p-7 md:p-9">
              <span className="text-gradient text-[48px] font-semibold leading-none tracking-[-0.03em] md:text-[56px]">
                {step.number}
              </span>
              <h3 className="text-[21px] font-semibold tracking-[-0.005em] text-ink md:text-[24px]">
                {step.title}
              </h3>
              <p className="text-[15px] leading-[1.55] text-muted md:text-[17px]">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
